// Haversine distance helpers
export function distanceKm(lat1, lon1, lat2, lon2) {
  if ([lat1, lon1, lat2, lon2].some((v) => v == null)) return null;
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) * Math.sin(dLon / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

export function formatKm(km) {
  if (km == null) return "";
  if (km < 1) return `${Math.round(km * 1000)} m away`;
  return `${km.toFixed(1)} km away`;
}

const MI_PER_KM = 0.621371;

export function formatDistance(km, unit = "km") {
  if (km == null) return "";
  if (unit === "mi") {
    const mi = km * MI_PER_KM;
    if (mi < 0.2) return `${Math.round(mi * 5280)} ft away`;
    return `${mi.toFixed(1)} mi away`;
  }
  return formatKm(km);
}

// Radius options (returns km thresholds + display labels) for the chosen unit.
// The widest option is a hard cap, never "anywhere": "deals near you" listing a shop on another
// continent because nothing was nearby is worse than an honest empty state.
export function radiusOptions(unit = "km") {
  if (unit === "mi") {
    return { km: [3 / MI_PER_KM, 6 / MI_PER_KM, 15 / MI_PER_KM, 30 / MI_PER_KM, 60 / MI_PER_KM], labels: ["3 mi", "6 mi", "15 mi", "30 mi", "60 mi"] };
  }
  return { km: [5, 10, 25, 50, 100], labels: ["5 km", "10 km", "25 km", "50 km", "100 km"] };
}

// Google Maps turn-by-turn directions link to a coordinate.
export function directionsUrl(lat, lng) {
  if (lat == null || lng == null) return null;
  return `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
}

// Google's encoded polyline format -> [{lat, lng}]. Done here so the map never has to load the
// JS geometry library just to draw a route the backend already worked out.
export function decodePolyline(encoded) {
  if (!encoded) return [];
  const pts = [];
  let i = 0, lat = 0, lng = 0;
  while (i < encoded.length) {
    let shift = 0, result = 0, byte;
    do { byte = encoded.charCodeAt(i++) - 63; result |= (byte & 0x1f) << shift; shift += 5; } while (byte >= 0x20);
    lat += (result & 1) ? ~(result >> 1) : (result >> 1);
    shift = 0; result = 0;
    do { byte = encoded.charCodeAt(i++) - 63; result |= (byte & 0x1f) << shift; shift += 5; } while (byte >= 0x20);
    lng += (result & 1) ? ~(result >> 1) : (result >> 1);
    pts.push({ lat: lat / 1e5, lng: lng / 1e5 });
  }
  return pts;
}
